export default "__VITE_ASSET__0926686c__"